import { render } from "./BlogForm.vue?vue&type=template&id=0cf000be&scoped=true&ts=true"
import script from "./BlogForm.vue?vue&type=script&lang=ts"
export * from "./BlogForm.vue?vue&type=script&lang=ts"

import "./BlogForm.vue?vue&type=style&index=0&id=0cf000be&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cf000be"]])

export default __exports__